import { memo, useEffect, useState } from 'react';
import { Bell, MagnifyingGlass, SlidersHorizontal } from '@phosphor-icons/react';
import { FARBE } from '../pille-stil';

interface IdleContentProps {
  /** Die ruhende Pille wird gerade gehovert (hover-peek) */
  peeking: boolean;
  /** Anzahl ungelesener Benachrichtigungen */
  unread: number;
  /** Label der Seite, die Steuerungselemente registriert hat (falls vorhanden) */
  pageLabel: string | null;
}

/** Uhrzeit HH:MM – eigene Komponente, damit nur sie alle 15 s neu zeichnet. */
export const Uhr = memo(function Uhr() {
  const [jetzt, setJetzt] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setJetzt(new Date()), 15_000);
    return () => clearInterval(t);
  }, []);
  return (
    <span className="shrink-0 tabular-nums" style={{ fontSize: 13, fontWeight: 700, color: 'rgba(255,255,255,0.86)' }}>
      {jetzt.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}
    </span>
  );
});

/** Ruhende Pille (Handoff Pille §3): Statuspunkt · Uhrzeit · Bereich; Hover „… steuern ⌘K“. */
export function IdleContent({ peeking, unread, pageLabel }: IdleContentProps) {
  const zeigeText = peeking || pageLabel !== null || unread > 0;
  const punkt = unread > 0 ? FARBE.gold : '#5fd38a';
  return (
    <div className="flex h-full items-center justify-center" style={{ gap: 9, padding: '0 16px' }}>
      <span className="relative flex shrink-0" style={{ width: 8, height: 8 }} aria-hidden>
        {unread > 0 && <span className="absolute inset-0 rounded-full pille-ping" style={{ background: punkt }} />}
        <span className="relative rounded-full" style={{ width: 8, height: 8, background: punkt, boxShadow: `0 0 8px ${punkt}` }} />
      </span>
      <Uhr />
      {zeigeText && (
        <>
          <span aria-hidden className="shrink-0 rounded-full" style={{ width: 3, height: 3, background: 'rgba(255,255,255,0.35)' }} />
          <span className="flex min-w-0 items-center" style={{ gap: 5, fontSize: 12, fontWeight: 600, color: 'rgba(255,255,255,0.78)' }}>
            {peeking ? (
              <>
                {pageLabel
                  ? <SlidersHorizontal size={12} weight="bold" color={FARBE.gold} className="shrink-0" />
                  : <MagnifyingGlass size={12} weight="bold" color={FARBE.gold} className="shrink-0" />}
                <span className="truncate">{pageLabel ? `${pageLabel} steuern` : 'Suche'}</span>
                <kbd className="shrink-0" style={{ height: 18, padding: '0 5px', borderRadius: 6, fontSize: 10, fontWeight: 800, lineHeight: '18px', background: 'rgba(255,255,255,0.12)', boxShadow: 'inset 0 0 0 0.5px rgba(255,255,255,0.2)', fontFamily: 'inherit' }}>
                  ⌘K
                </kbd>
              </>
            ) : pageLabel ? (
              <>
                <SlidersHorizontal size={12} weight="bold" color={FARBE.gold} className="shrink-0" />
                <span className="truncate">{pageLabel}</span>
              </>
            ) : (
              <>
                <Bell size={12} weight="fill" color={FARBE.gold} className="shrink-0" />
                <span className="truncate">{unread} neu</span>
              </>
            )}
          </span>
        </>
      )}
    </div>
  );
}
